import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`svg {
    display: block;
}
`); export default styleSheet;